import React from 'react'

import UIMainMenuContainer from '../../../menu/main-menu'
import MinimizeButton from '../../../../core/gd-ui/minimize-button/minimize-button'
import ErrorBoundary from "../../../../core/error-boundary"
import {SESSION_COMPANY_CHANGE} from "../../../../core/gd/bus/bus-event-type";

type Props = {

}

// const debug = "UILeft"
const debug = false

export default class UILeftTeams extends React.Component<Props> {

    public currentSection   : any // ?????

    constructor(props:Props) {
        super(props);

        debug && console.log(debug, "constructor")

        this.currentSection = gd.ac.components.getDefaultComponentId()
    }

    componentDidMount() {
        gd.layout.left = this;

        gd.bus.subscribe('layout-left-changed', this, this.onToggleForceMin)
        gd.bus.subscribe(SESSION_COMPANY_CHANGE, this, this.reRender)
        gd.bus.subscribe('menu:vertical-separator-resize-left', this, this.onResizeMenu)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    reRender = () => {
        this.forceUpdate()
    }

    onToggleForceMin = () => {
        debug && console.log(debug, "onToggleForceMin()")
        this.onResizeMenu(gd.layout.localSettings.menuWidth)
    }

    onResizeMenu = (value:number, percentValue?:number) => {
        debug && console.log(debug,"onResizeMenu()")

        gd.layout.localSettings.menuWidth   = value

        gd.layout.applyStyles()
        gd.layout.calculateWidth()
    }

    onToggleMenuClick = async (e:React.SyntheticEvent) => {
        e.stopPropagation()

        debug && console.log(debug, "onToggleMenuClick", gd.getApp())

        gd.layout.toggleForceMin()

        if (!gd.layout.navigation.state.currentSection) {
            await gd.getApp().updateMainNavigation()
        }
    }

    render() {
        debug && console.green(debug, "Left render() menuState=", gd.layout.menuState)

        const styles = {
            width   : gd.layout.localSettings.menuWidth + 'px',
            left    : gd.layout.uiLeftLeftPosition + 'px',
            top     : 2, // 48,
            // height  : "calc(100% - 48px)",
            height  : "calc(100% - 2px)",
        }

        let menuTheme = gd.ui.uiLeftMenuThemeClass

        const classesLeft = Classes('ui-left-teams', gd.layout.type,  menuTheme, {
            'no-minimize-btn': gd.layout.shouldHideMenuBecauseOfScreenSize || gd.layout.isMenuHiddenForCurrentApp,
            // 'closed': gd.layout.shouldHideMenuBecauseOfScreenSize || gd.layout.isMenuHiddenForCurrentApp
        })

        debug && console.log(debug, 'render()', gd.layout.shouldHideMenuBecauseOfScreenSize, gd.layout.isMenuHiddenForCurrentApp, styles, classesLeft)

        return (
            <div id="ui-left" className={classesLeft} style={styles}>
                <ErrorBoundary>
                    <MinimizeButton skin            = {gd.skin.layoutTheme}
                                    onToggleClick   = {this.onToggleMenuClick}/>
                    <UIMainMenuContainer />
                </ErrorBoundary>
            </div>
        )
    }
}
